import { JobsTable } from "@/components/jobs/jobs-table";
import { createFileRoute } from "@tanstack/react-router";

function JobsPage() {
  return <JobsTable />;
}

export const Route = createFileRoute("/_authenticated/website/jobs/")({
  component: JobsPage,
});
